import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import Card from '../../../../../components/Card'
import { api, authHeaders } from '../../../../../services/api'
import { Button, Textbox } from '../../../../../components/Form'
import Modal from '../../../../../components/Modal'
import { FiPlus } from 'react-icons/fi'
import Table from '../../../../../components/Table'
import masks from '../../../../../util/masks'
import formUtils from '../../../../../util/form'

const initialValues = {
	nome: '',
	fone: '',
	email: '',
	cpf: ''
}

export default function () {
	const { id } = useParams()

	const queryClient = useQueryClient()

	const [isCreateAdminOpen, setIsCreateAdminOpen] = useState(false)

	const { data: admins } = useQuery({
		queryKey: ['get-parceiro-admins'],
		queryFn: async () => {
			const response = await api.get(`parceiro/${id}/admins`, authHeaders())

			return response?.map(admin => ({
				nome: admin.admin.nome,
				cpf: admin.admin.documentos.find(d => d.tipo_documento_id === 2)?.identificador || '',
				email: admin.admin.contato.find(c => c.tipo_contato_id === 6)?.contato || '',
				fone: admin.admin.contato.find(c => c.tipo_contato_id === 4)?.contato || ''
			}))
		},
		enabled: !!authHeaders()
	})

	const { mutate: handleSubmit, isPending: isCreatingAdmin } = useMutation({
		mutationFn: async values => {
			values = formUtils.extractFormValues(values)

			await api.post(`parceiro/${id}/admins`, values, authHeaders())
		},
		onSuccess() {
			setIsCreateAdminOpen(false)

			toast.success('Administrador cadastrado com sucesso!')

			queryClient.invalidateQueries({
				queryKey: ['get-parceiro-admins']
			})
		},
		onError(e) {
			toast.error(e.msg)
		}
	})

	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Administradores</h1>

				<Button onClick={() => { setIsCreateAdminOpen(true) }} className='w-fit self-end'>
					Novo administrador
					<FiPlus />
				</Button>

				<Table
					headers={[
						{ name: 'nome', value: 'Nome' },
						{ name: 'cpf', value: 'CPF', centered: true },
						{ name: 'email', value: 'E-mail', centered: true },
						{ name: 'fone', value: 'WhatsApp', centered: true }
					]}
					data={admins}
				/>
			</Card>

			<Modal
				isOpen={isCreateAdminOpen}
				handleClose={() => setIsCreateAdminOpen(false)}
				title="Novo administrador"
			>
				<Formik
					onSubmit={handleSubmit}
					initialValues={initialValues}
					enableReinitialize
				>
					{() => (
						<Form className="flex flex-col gap-6">
							<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
								<Textbox
									name="nome"
									label="Nome"
								/>

								<Textbox
									name="cpf"
									label="CPF"
									mask={masks.cpf}
								/>

								<Textbox
									name="fone"
									label="Fone"
									mask={masks.mobile}
								/>

								<Textbox
									name="email"
									label="E-mail"
								/>
							</div>

							<Button type="submit" className="self-end" loading={isCreatingAdmin}>
								Cadastrar
							</Button>
						</Form>
					)}
				</Formik>
			</Modal>
		</div>
	)
}
